// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"adccd0de","45":"3a5fc967","315":"b7561d16","404":"953c5622","498":"43112e25","733":"b93e6625","802":"52684fad"}[chunkId] + ".chunk.js";
};